import React, { useState, useEffect } from "react";
  import Swal from "sweetalert2";
  import $ from "jquery";

const Question = ({ item, hasIndex, index }) => {
  const [total, setTotal] = useState();
  const [hasAnswers, setHasAnswers] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const [isIndex, setIsIndex] = useState("");
  const [questions, setQuestion] = useState([]);
  const [tryAgain, setTryAgain] = useState(false);

  useEffect(() => {
    const data = item.questions.map((ele) => {
      return { _id: ele._id, answer: "" };
    });
    setQuestion(data);
  }, []);

  const addQuestion = (id, keyName) => {
    questions.forEach((e, i) => {
      if (e._id === id) {
        questions[i].answer = keyName;
      }
    });
  };

  const handleChangeColor = (e, i) => {
    const answerOptions = document.querySelectorAll(`.answer-options${i}`);
    if (e.target.classList.contains("answer")) {
      answerOptions.forEach((item) => {
        item.classList.remove("my-option");
      });
      e.target.classList.add("my-option");
    }
  };
  // function copyAlert(msg) {
  //   let timerInterval;
  //   Swal.fire({
  //     title: msg,
  //     timer: 5000,
  //     // timerProgressBar: true,

  //     willClose: () => {
  //       clearInterval(timerInterval);
  //     },
  //   }).then((result) => {
  //     /* Read more about handling dismissals below */
  //     if (result.dismiss === Swal.DismissReason.timer) {
  //       console.log("I was closed by the timer");
  //     }
  //   });


  // }
  const handleSubmit = (e, quizzesId, i) => {
    e.preventDefault();
    setIsIndex(i);

    setIsPending(true);

    fetch(`${process.env.REACT_APP_BASE_URL}/submit-quiz/${quizzesId}`, {
      method: "POST",
      body: JSON.stringify({
        questions: questions,
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })

      .then(async (data) => {
        const res =  await data.json()
        if (!data.ok) {
          alert(res.msg)
          
         // copyAlert(res.msg)
          throw res.msg
        }
        return res
      })
      .then((res) => {
        console.log("55");
        setIsPending(false);
        setHasAnswers(res.msg.answers);
        setTotal(res.msg.total);
        setTryAgain(true);
      })
      .catch((err) => {
        console.log("53");
        console.log("61", err);
      })

  };

  const handleTryAgain = () => {
    hasAnswers?.forEach((item, index) => {
      const answerOptions = document.querySelectorAll(
        `.answer-options${index}`
      );

      answerOptions.forEach((ele, i) => {
        ele.classList.remove("fault-option");
        ele.classList.remove("correct-option");
        ele.classList.remove("my-option");
      });
    });

    setTotal();
    setHasAnswers([]);
    setTryAgain(false);
  };

  useEffect(() => {
    hasAnswers?.forEach((item, index) => {
      const answerOptions = document.querySelectorAll(
        `.answer-options${index}`
      );

      answerOptions.forEach((ele, i) => {
        let data = ele.getAttribute("data-option");
        let question = ele.getAttribute("data-question");

        if (question === isIndex.toString()) {
          ele.classList.remove("fault-option");

          if (item.selected === data) {
            ele.classList.add("fault-option");
          }

          if (item.answer === data) {
            ele.classList.add("correct-option");
          }
          ele.classList.remove("my-option");
        }
      });
    });
  }, [hasAnswers, isIndex]);

  return (
    <div>
      {total >= 0 && (
        <div className="ReadingInside-right-score">
          <div className="question-score">
            <span>Score</span>
            <div className="score-bar">
              <span>{total} / 5</span>
            </div>
          </div>
        </div>
      )}
      <div className={`ReadingInside-right-questions question-${index + 1}`}>
        <h4 className="question-title">Questions of {item.name}:</h4>

        {item.questions?.map((item, ind) => (
          <div key={ind} className="question-component">
            <div className="question-number">
              <h2>{ind + 1}</h2>
            </div>
            <h3 className="question-real">{item.question_name}</h3>

            {Object.entries(item.options).map(([keyName, sub], i) => (
              <button
                className={`answer answer-options${ind} `}
                key={i}
                onClick={(e) => {
                  addQuestion(item._id, keyName);
                  handleChangeColor(e, ind);
                }}
                type="button"
                data-option={`${keyName}`}
                data-question={`${hasIndex}`}
                disabled={tryAgain}
              >
                <div style={{pointerEvents : "none"}}>
                  <h2 style={{pointerEvents : "none"}}>{keyName}</h2>
                </div>
                <h3 style={{pointerEvents : "none"}}>{sub}</h3>
              </button>
            ))}
          </div>
        ))}
        {tryAgain ? (
          <button className="but-reading-inside" onClick={handleTryAgain}>
            Try Again
          </button>
        ) : (
          <button
            className="but-reading-inside"
            onClick={(e) => handleSubmit(e, item._id, index)}
          >
            {" "}
            {!isPending ? "Finish" : "Finishing"}
          </button>
        )}
      </div>
    </div>
  );
};

export default Question;
